export const generateIds = () => {
  const a = new Date().getTime() * Math.random()
  const b = a * Math.random() * 2 * Math.random()
  const c = Math.floor((a * b * Math.random()) / b)
  return c.toString(36)
}
